var map = {
	"./chart.svg": 80866,
	"./discord.svg": 15490,
	"./flex.svg": 82612,
	"./holidays.svg": 15859,
	"./mobile.svg": 87096,
	"./off.svg": 56974,
	"./office.svg": 32220,
	"./push2.svg": 81759,
	"./remote.svg": 92064,
	"./responsive.svg": 38328,
	"./schedules.svg": 4989,
	"./slack.svg": 77129,
	"./teams.svg": 11386,
	"./timezone.svg": 14829,
	"./transparency.svg": 19446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92103;